import commonStrings from 'resources/commonStrings';

export const operationalReportResources = [
  {
    title: commonStrings.reportResourceSectionTitle.resourcesAndGuides,
    resources: [
      {
        link: {
          displayText: commonStrings.reportResourceLink.operationalReportsSummary,
          target: 'https://teach.mapnwea.org/assist/doc/QRM2_Operational_Reports_Summary_QuickRef.pdf',
        },
        description: commonStrings.reportResourceDescription.operationalReportsSummary,
        analytics: {
          category: 'rlp-operational-reports',
          label: 'operational-reports-summary',
        },
      },
      {
        link: {
          displayText: commonStrings.reportResourceLink.operationalReportsReference,
          target: 'https://teach.mapnwea.org/assist/doc/PGM2_Operational_Reports_Reference.pdf',
        },
        description: commonStrings.reportResourceDescription.operationalReportsReference,
        analytics: {
          category: 'rlp-operational-reports',
          label: 'operational-reports-reference',
        },
      },
    ],
  },
];

export default operationalReportResources;
